import React, { useState, useEffect } from 'react';
import dataProvider from "providers/dataProvider"
import { DOWNLOAD_FILE_GET } from 'providers/dataProvider';
import { useNotificationCenter } from 'NotificationCenter';
import {
  Delivery2Icon
} from 'icons'
import { TableHeaderAddButton } from 'components/ui_components/buttons';
import PropTypes from 'prop-types';

const ExportAllButton = ({ resource, filter }) => {
  const [downloadReportsInProgress, setDownloadReportsInProgress] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(filter || {});
  const notificationCenter = useNotificationCenter();

  // Keep filters synchronized with props
  useEffect(() => {
    setCurrentFilters(filter || {});
  }, [filter]);

  const handleDownloadReport = () => {
    setDownloadReportsInProgress(true);
    
    let params;
    
    if (resource === 'collaborators/export') {
      params = {};
      if (Object.keys(currentFilters).length > 0) {
        const filterParts = Object.entries(currentFilters).map(([key, value]) => `${key}:${value}`);
        params.filter = `[${filterParts.join(',')}]`;
      }
    } else if (resource === 'freezer_specs/export') {
      params = {};
      if (Object.keys(currentFilters).length > 0) {
        const filterParts = Object.entries(currentFilters).map(([key, value]) => `${key}:${value}`);
        params.filter = `[${filterParts.join(',')}]`;
      }
    } else {
      params = {
        filter: currentFilters,
        filterActive: Object.keys(currentFilters).length > 0
      };
    }

    dataProvider(DOWNLOAD_FILE_GET, resource, params)
      .then(({ data }) => {
        
        // Handle freezer export format: {url, retval: 'SUCCESS'}
        if (data && data.url && data.retval === 'SUCCESS') {
          window.open(data.url);
          notificationCenter.show(
            'If download failed, please click here',
            'info',
            'Download',
            () => {},
            data.url
          );
        }
        // Handle nested exportUrl format (original format)
        else if (data && data.data && data.data.exportUrl) {
          window.open(data.data.exportUrl);
          notificationCenter.show(
            'If download failed, please click here',
            'info',
            'Download',
            () => {},
            data.data.exportUrl
          );
        }
        // Regular format for other exports with url
        else if (data && data.url) {
          window.open(data.url);
          notificationCenter.show(
            'If download failed, please click here',
            'info',
            'Download',
            () => {},
            data.url
          );
        }
        // Handle empty response
        else if (Array.isArray(data) && data.length === 0) {
          notificationCenter.show('No matching records found for export', 'info');
        }
        // Unexpected format
        else {
          console.error('Unexpected export response format:', data);
          notificationCenter.show('Export failed with unexpected response format', 'warning');
        }
        
        setDownloadReportsInProgress(false);
      }).catch(error => {
        notificationCenter.show(error.message || 'Export failed', 'warning');
        setDownloadReportsInProgress(false);
        console.error('Export error:', error);
      });
  }

  // Keep the title tooltip to inform users about filters, but maintain button text as 'Export All'
  const hasFilters = currentFilters && Object.keys(currentFilters).length > 0;
  
  return (
    <TableHeaderAddButton
      onClick={handleDownloadReport}
      showProgressBar={downloadReportsInProgress}
      icon={<Delivery2Icon/>}
      title={hasFilters ? `Export records matching current filters (${Object.keys(currentFilters).length} active)` : 'Export all records'}
      data-testid="export-all-button"
    >
      Export All
    </TableHeaderAddButton>
  )
}

export default ExportAllButton;

ExportAllButton.propTypes = {
  resource: PropTypes.string.isRequired,
  filter: PropTypes.object
}

ExportAllButton.defaultProps = {
  filter: {}
}